export enum ParkingCarType {
  passengerCar,
  lightTruck,
  heavyTruck,
  motorcycle,
  bus,
  motorhome,
  trailer,
}
